
import { ThreeView } from "./index";
import { ModelDragController, ModelRotateController } from "./ItemDrag";
import { defines, WalkThroughCameraControl, OrbitCameraControl } from "../base";
import * as marietta from '../../../marietta';

export class View3dController {

    constructor() {}

    private WalkThrought() {
        const wrkth = ThreeView.get().wcCameras.getCamera(defines.CameraDefs.wlkthCamNo);
        return (<WalkThroughCameraControl>wrkth.control)._instance;
    }
    private orbit() {
        const orbit = ThreeView.get().wcCameras.getCamera(defines.CameraDefs.orbitCamNo);
        return (<OrbitCameraControl>orbit.control)._instance;
    }

    public pickerOver(e) {
        console.log(e.value);

        const dragController = <ModelDragController>ThreeView.get().ItemDragManager.dragController;
        const rotateController = <ModelRotateController>ThreeView.get().ItemDragManager.rotateController;

        dragController.controller.enabled = false;
        if (rotateController && rotateController.transFormControls) rotateController.transFormControls.enabled = false;
        ThreeView.get().ItemDragManager.enabled = false;
        ThreeView.get().ObjectSelectManager.enabled = false;
        this.WalkThrought().enabled = false;
        this.orbit().enabled = false;

        ThreeView.get().ItemDragManager.hideBBOX();

        if (e.value == 'movePicker') {
            dragController.controller.enabled = true;

        }
        if (e.value == 'spinPicker') {
            if (rotateController && rotateController.transFormControls) rotateController.transFormControls.enabled = true;
        }
        if (e.value == 'sizepicker') {
            ;
        }
        if (e.value == 'deletepicker') {
            ;
        }
        if(e.value == 'textPicker') {
            ;
        }

        // this.description();
    }

    public pickerOut(e) {
        const dragController = <ModelDragController>ThreeView.get().ItemDragManager.dragController;
        const rotateController = <ModelRotateController>ThreeView.get().ItemDragManager.rotateController;

        if (dragController.isMouseDown || ( rotateController && rotateController.isMouseDown )) return;

        console.log(e.value);

        ThreeView.get().ItemDragManager.showBBOX();

        // if (e.value == 'movePicker' || e.value == 'spinPicker' || e.value == 'sizepicker' || e.value == 'deletepicker' || e.value == 'duplicatePicker' || e.value == 'textPicker') {
        dragController.controller.enabled = false;
        if (rotateController && rotateController.transFormControls) rotateController.transFormControls.enabled = false;
        ThreeView.get().ItemDragManager.enabled = true;
        ThreeView.get().ObjectSelectManager.enabled = true;

        this.WalkThrought().enabled = ThreeView.get().wcCameras.isWalkThroughCameraMode();
        this.orbit().enabled = ThreeView.get().wcCameras.isOrbitCameraMode();
        // }

        // this.description();
    }

    private SetItemDragManager(flag: boolean) {
        if (!ThreeView.get().ItemDragManager) return;
        ThreeView.get().ItemDragManager.enabled = flag;
    }
    private SetWallSelectManager(flag: boolean) {
        if (!ThreeView.get().ObjectSelectManager) return;
        ThreeView.get().ObjectSelectManager.enabled = flag;
    }
    private SetDragCOntroller(flag: boolean) {
        if (!ThreeView.get().ItemDragManager) return;
        const dragController = <ModelDragController>ThreeView.get().ItemDragManager.dragController;
        if (dragController) {
            dragController.controller.enabled = flag;
        }
    }
    private SetRotateController(flag: boolean) {
        if (!ThreeView.get().ItemDragManager) return;
        const rotateController = <ModelRotateController>ThreeView.get().ItemDragManager.rotateController;
        if (rotateController && rotateController.transFormControls) {
            rotateController.transFormControls.enabled = flag;
        }
    }

    public minimapIn() {
        this.SetItemDragManager(false);
        this.SetDragCOntroller(false);
        this.SetRotateController(false);

        this.SetWallSelectManager(false);

        this.WalkThrought().enabled = false;
        this.orbit().enabled = false;

        // this.description();
    }

    public minimapOut() {
        this.SetItemDragManager(true);
        this.SetDragCOntroller(false);
        this.SetRotateController(false);

        this.SetWallSelectManager(true);

        this.WalkThrought().enabled = ThreeView.get().wcCameras.isWalkThroughCameraMode();
        this.orbit().enabled = ThreeView.get().wcCameras.isOrbitCameraMode();

        // this.description();
    }

    public pickerDown(e) {
        if (marietta.webcad.WebCADGlobal.currentDialog instanceof marietta.webcad.view.dialog.ItemChangeDialog) {
            marietta.webcad.WebCADGlobal.currentDialog.closeEvent();
        }

        // this.description();
    }

    public pinPictureOver(e) {
        console.log(e.value);

        ThreeView.get().ItemDragManager.enabled = false;
        ThreeView.get().ObjectSelectManager.enabled = false;
        this.WalkThrought().enabled = false;
        this.orbit().enabled = false;

        ThreeView.get().ItemDragManager.hideBBOX();        
    }

    public pinPictureOut(e) {
        console.log(e.value);

        ThreeView.get().ItemDragManager.showBBOX();
        ThreeView.get().ItemDragManager.enabled = true;
        ThreeView.get().ObjectSelectManager.enabled = true;

        this.WalkThrought().enabled = ThreeView.get().wcCameras.isWalkThroughCameraMode();
        this.orbit().enabled = ThreeView.get().wcCameras.isOrbitCameraMode();
    }

    public controllerSetUp() {
        this.unSelected();
    }
    public unSelected() {
        if (ThreeView.get().ItemDragManager) {
            const dragController = <ModelDragController>ThreeView.get().ItemDragManager.dragController;
            if (dragController && dragController.controller) dragController.controller.enabled = false;
            if (dragController) {
                dragController.controller.enabled = false;
            }

            const rotateController = <ModelRotateController>ThreeView.get().ItemDragManager.rotateController;
            if (rotateController && rotateController.transFormControls) rotateController.transFormControls.enabled = false;

            // ThreeView.get().ItemDragManager.enabled = ThreeView.get().wcCameras.isWalkThroughCameraMode();          // 外観モードでは有効にしない
            ThreeView.get().ItemDragManager.enabled = true;
            ThreeView.get().ItemDragManager.hideBBOX();                                                             // BBOXは非表示
        }

        if (ThreeView.get().ObjectSelectManager){
            // ThreeView.get().wallSelectManager.enabled = ThreeView.get().wcCameras.isWalkThroughCameraMode();        // 外観モードでは有効にしない
            ThreeView.get().ObjectSelectManager.enabled = true;
        }

        this.WalkThrought().enabled = ThreeView.get().wcCameras.isWalkThroughCameraMode();
        this.orbit().enabled = ThreeView.get().wcCameras.isOrbitCameraMode();

        // this.description();
    }

    public description() {
        const dragController = <ModelDragController>ThreeView.get().ItemDragManager.dragController;
        const rotateController = <ModelRotateController>ThreeView.get().ItemDragManager.rotateController;

        console.log(`WalkThroughCameraControl ${this.WalkThrought().enabled}`);

        if (dragController && dragController.controller) console.log(`ModelDragController ${dragController.controller.enabled}`);
        if (rotateController && rotateController.transFormControls) console.log(`ModelRotateController ${rotateController.transFormControls.enabled}`);
        console.log(`ItemDragManager ${ThreeView.get().ItemDragManager.enabled}`);

    }
}
